/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { DOCUMENTS } from "./globalVars";
import { ALIMONY_APPLICATION_STATUS_SET } from "./alimony/applicationStatus";
import { DEATH_APPLICATION_STATUS_SET } from "./death/applicationStatus";
import * as documentStatus from "./document/leadStatus";
import { getCaseLink } from "./productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { AbstractPurchasable } from "@/src/types/Entities/AbstractPurchasable";

export const getMaxApplicationStatus = (documentType: string) => {
  switch (documentType) {
    case "alimony":
      return ALIMONY_APPLICATION_STATUS_SET[ALIMONY_APPLICATION_STATUS_SET.length - 1];
    case "death":
      return DEATH_APPLICATION_STATUS_SET[DEATH_APPLICATION_STATUS_SET.length - 1];
    default:
      return 100;
  }
};

export const getDocumentParams = (documentType: string) => {
  switch (documentType) {
    case "alimony":
      return DOCUMENTS.alimony;
    case "death":
      return DOCUMENTS.death;
    default:
      return null;
  }
};

export const getDocumentType = (entity: AbstractCase) => {
  const name = entity.checkoutItem && entity.checkoutItem.name;
  switch (name) {
    case "Außergerichtliche Vertretung":
      return "traffic";
    case "Unterhalt":
      return "alimony";
    case "Tod und Erbe":
      return "death";
    default:
      return "none";
  }
};

export const getCurrentLink = (entity: AbstractPurchasable) => {
  return entity.leadStatus < documentStatus.STATUS_CHECKED ? getApplicationLink(entity) : getCheckoutLink(entity);
};

export const getApplicationLink = (entity: AbstractCase) => {
  const documentType = getDocumentType(entity);
  const documentParams = getDocumentParams(documentType);
  if (!documentParams) {
    return "/servicewelt";
  }
  return getCaseLink(entity) + "/antrag";
};

export const getCheckoutLink = (entity: AbstractPurchasable) => {
  return "/checkout/?orderId=" + entity.checkoutItem.id + "_" + entity.id;
};
